import { useTranslation } from 'react-i18next';
import i18n, {
  authenticatedLanguageStorageKey,
  manualLanguageOverrideStorageKey,
  normalizeSupportedLanguage,
  supportedLanguages,
} from 'i18n';

import './LanguageSelector.css';

const languageFlags: Record<typeof supportedLanguages[number], string> = {
  fr: 'FR',
  en: 'EN',
  es: 'ES',
};

const languageIcons: Record<typeof supportedLanguages[number], string> = {
  fr: '🇫🇷',
  en: '🇬🇧',
  es: '🇪🇸',
};

const LanguageSelector = () => {
  const { t } = useTranslation();
  const currentLanguage = normalizeSupportedLanguage(i18n.resolvedLanguage) ?? 'fr';

  const onSelectLanguage = async (language: typeof supportedLanguages[number]) => {
    localStorage.setItem(authenticatedLanguageStorageKey, language);
    localStorage.setItem(manualLanguageOverrideStorageKey, 'true');

    if (i18n.resolvedLanguage !== language) {
      await i18n.changeLanguage(language);
    }
  };

  return (
    <div className="language-selector-wrapper">
      <label className="language-selector-label">{t('common.language')}</label>
      <div className="language-selector" aria-label="Language selector">
        {supportedLanguages.map((language) => (
          <button
            key={language}
            type="button"
            className={`language-chip ${currentLanguage === language ? 'active' : ''}`}
            onClick={() => onSelectLanguage(language)}
            aria-label={`Choose ${languageFlags[language]}`}
            title={languageFlags[language]}
          >
            <span className="language-chip-icon" aria-hidden="true">{languageIcons[language]}</span>
            <span className="language-chip-text">{languageFlags[language]}</span>
          </button>
        ))}
      </div>
    </div>
  );
};

export default LanguageSelector;